import React, { useState, useEffect } from 'react';
import apiClient from '../utils/apiClient';
import EducationForm from '../components/EducationForm';

const EducationPage = () => {
  const [educations, setEducations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingEdu, setEditingEdu] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    fetchEducations();
  }, []);

  const fetchEducations = async () => {
    setIsLoading(true);
    setError('');
    try {
      const response = await apiClient.get('/education');
      setEducations(response.data || []);
    } catch (err) {
      setError('Failed to load educations');
      setEducations([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddEducation = () => {
    setEditingEdu(null);
    setShowModal(true);
  };

  const handleEditEducation = (edu) => {
    setEditingEdu(edu);
    setShowModal(true);
  };

  const handleDeleteEducation = async (id) => {
    if (!window.confirm('Are you sure you want to delete this education?')) {
      return;
    }

    try {
      await apiClient.delete(`/education/${id}`);
      setEducations(educations.filter(e => e.id !== id));
      showSuccess('Education deleted successfully');
    } catch (err) {
      setError('Failed to delete education');
    }
  };

  const handleSaveEducation = async (eduData) => {
    try {
      if (editingEdu) {
        const response = await apiClient.put(`/education/${editingEdu.id}`, eduData);
        setEducations(educations.map(e => e.id === editingEdu.id ? response.data : e));
        showSuccess('Education updated successfully');
      } else {
        const response = await apiClient.post(`/education`, eduData);
        setEducations([...educations, response.data]);
        showSuccess('Education created successfully');
      }
      setShowModal(false);
    } catch (err) {
      setError('Failed to save education');
    }
  };

  const showSuccess = (message) => {
    setSuccessMessage(message);
    setTimeout(() => setSuccessMessage(''), 3000);
  };

  return (
    <div>
      <div className="content-header">
        <h2>Education Management</h2>
        <button className="add-btn" onClick={handleAddEducation}>
          + Add New Education
        </button>
      </div>

      {successMessage && <div className="alert alert-success">{successMessage}</div>}
      {error && <div className="alert alert-error">{error}</div>}

      {isLoading ? (
        <div className="table-container">
          <div className="no-data">Loading educations...</div>
        </div>
      ) : educations.length === 0 ? (
        <div className="table-container">
          <div className="no-data">No educations yet. Add your first education!</div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {educations.map(edu => (
            <div key={edu.id} className="message-card" style={{ borderLeftColor: '#27ae60' }}>
              <h4>🎓 {edu.degree}</h4>
              <div style={{ color: '#667eea', fontSize: '14px', marginBottom: '10px' }}>
                {edu.institution}
              </div>
              <div style={{ color: '#999', fontSize: '13px', marginBottom: '10px' }}>
                📅 {edu.period}
              </div>
              <p>{edu.description}</p>
              <div className="action-buttons" style={{ marginTop: '10px' }}>
                <button className="edit-btn" onClick={() => handleEditEducation(edu)}>
                  Edit
                </button>
                <button className="delete-btn" onClick={() => handleDeleteEducation(edu.id)}>
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <EducationForm
              education={editingEdu}
              onSave={handleSaveEducation}
              onCancel={() => setShowModal(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default EducationPage;
